import React from "react";
import { InputSelectComponentProps } from "../../../lib/types/types";
import { StatusComponent } from "../Status/StatusComponent";

export const FirstResponderStatus = ({
  value,
  isErrored,
  options,
  onChange,
  placeholder = "",
  onKeyDown = undefined,
}: InputSelectComponentProps) => (
  <StatusComponent
    segmentId="first-responder"
    value={value}
    isErrored={isErrored}
    errorId="invalidFirstResponderStatus"
    options={options}
    onChange={onChange}
    placeholder={placeholder}
    onKeyDown={onKeyDown}
  />
);

/**
 * @deprecated Use `<StatusComponent>` instead.
 */
export const FirstResponderStatusComponent = FirstResponderStatus;
